module.exports = __webpack_public_path__ + "static/media/data-export.cef6c0d8.png";